// extracted by mini-css-extract-plugin
export default {"menuItem":"styles_menuItem__RHy-u","menuItemInner":"styles_menuItemInner__V31p4"};